export const WEEKLY_SUMMARY_CONFIG_GROUP = "WEEKLY_SUMMARY";
export const WEEKLY_SUMMARY_SEND_DAY_KEY = "weekly_summary.send_day";
export const WEEKLY_SUMMARY_SEND_HOUR_KEY = "weekly_summary.send_hour";

export const DAY_OPTIONS: { value: number; label: string }[] = [
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
    { value: 7, label: "Sunday" },
];

export const hourLabel = (hour: number): string => {
    const h12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${h12}:00 ${hour < 12 ? "AM" : "PM"}`;
};

/** Mirrors marabot-api `WeeklySummaryRun` (GET /admin/weekly-summary/runs). */
export interface WeeklySummaryRun {
    periodKey: string;
    queued: number;
    sending: number;
    sent: number;
    skipped: number;
    failed: number;
    firstScheduledFor: string | null;
    lastSentAt: string | null;
}
